import { ReactNode } from 'react'

import { ButtonGroup } from '../ButtonGroup'
import { Button } from '../Buttons'
import { useDialog } from './context'

import * as SC from './styles'

type Props = {
  hasSubmit?: boolean
  hasCancel?: boolean

  submitText?: string
  cancelText?: string
  action?: ReactNode

  onSubmit?: () => Promise<void>
}

export const DialogFooter = (props: Props) => {
  const { hasSubmit, hasCancel, submitText, cancelText, action, onSubmit } = props

  const dialog = useDialog()

  const handleSubmit = async () => {
    dialog.pending(true)
    if (onSubmit) {
      await onSubmit()
    }
    dialog.pending(false)
  }

  const handleCancel = () => {
    dialog.close()
  }

  return (
    <SC.Footer>
      <ButtonGroup margin={'small'}>
        {hasSubmit && (
          <Button face={'primary'} loading={dialog.isPending} onClick={handleSubmit}>
            {submitText ?? 'Submit'}
          </Button>
        )}
        {hasCancel && (
          <Button face={'secondary'} onClick={handleCancel}>
            {cancelText ?? 'Cancel'}
          </Button>
        )}
      </ButtonGroup>
      {action && <SC.FooterAction data-testid="action">{action}</SC.FooterAction>}
    </SC.Footer>
  )
}
